$(document).on("turbolinks:load", function () {
  var $alwaysBtn = $("#btn-always-participate")
  var $letMeBtn = $("#btn-let-me-choose")

  if (!$alwaysBtn.length) return

  var $toggles = $(".js-promo-channel-toggle")

  // Initialize switches ourselves so instances are available immediately,
  // before application.js's turbolinks:load handler has a chance to run.
  $toggles.each(function () {
    this.switchButton()
  })

  function markActive($active, $inactive) {
    $active.removeClass("btn-outline-secondary").addClass("btn-primary")
    $inactive.removeClass("btn-primary").addClass("btn-outline-secondary")
  }

  function syncActiveButton() {
    var allOn =
      $toggles.length > 0 &&
      $toggles.filter(":checked").length === $toggles.length
    allOn
      ? markActive($alwaysBtn, $letMeBtn)
      : markActive($letMeBtn, $alwaysBtn)
  }

  // on(true)/off(true) suppresses the library's trigger() call so we don't get
  // intermediate syncActiveButton calls while iterating all three switches.
  function setAll(on) {
    $toggles.each(function () {
      on ? this.switchBtn.on(true) : this.switchBtn.off(true)
    })
  }

  syncActiveButton()

  // Use native addEventListener: the library fires dispatchEvent('change') natively.
  $toggles.each(function () {
    this.addEventListener("change", syncActiveButton)
  })

  $alwaysBtn.on("click", function (e) {
    e.preventDefault()
    setAll(true)
    markActive($alwaysBtn, $letMeBtn)
  })

  $letMeBtn.on("click", function (e) {
    e.preventDefault()
    setAll(false)
    markActive($letMeBtn, $alwaysBtn)
  })
})
